import partner from '@/views/partner/store';
import app from '@/store';

export const rootReducer = {
  app,
  partner,
};